import type { PromotionCurrencyTotal } from "@ticketnjoy/types";

import type { Format } from "@/lib/format";

/** Birden fazla para birimi varsa " · " ile birleştirir. */
export function formatMoneyTotals(
  totals: PromotionCurrencyTotal[],
  field: "discountTotal" | "revenueTotal",
  fmt: Format,
): string {
  if (totals.length === 0) return fmt.number(0);
  return totals.map((x) => fmt.money(x[field], x.currency)).join(" · ");
}
